// extracted by css-extract-rspack-plugin
export default {"heading":"kV7etC","files-heading":"kvTNEr","filesHeading":"kvTNEr"};